import React from 'react'
import { Button, Tag } from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'

const formatTime = (momentTime) => {
  return momentTime.format('h:mmA')
}

const formatDate = (momentTime) => {
  return momentTime.format('MMMM D, YYYY')
}

const AvailabilityItemView = ({ item, onEdit, onDelete, isSaving }) => {
  const isActive = item.is_active_for_inspection

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        <div style={{ fontWeight: 500, marginBottom: 4, display: 'flex', alignItems: 'center', gap: 8 }}>
          {formatDate(item.start)}
          <Tag color={isActive ? 'green' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>
        </div>
        <div style={{ color: '#666', fontSize: 14 }}>
          {formatTime(item.start)} - {formatTime(item.end)}
        </div>
      </div>
      <div>
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={() => onEdit(item.id)}
          disabled={isSaving}
          style={{ marginRight: 8 }}
        >
          Edit
        </Button>
        <Button type="text" danger icon={<DeleteOutlined />} onClick={() => onDelete(item.id)} disabled={isSaving} />
      </div>
    </div>
  )
}

export default AvailabilityItemView
